import React from "react";
import { useAuth } from "../../../../../hooks";
import { Grid } from "@mui/material";

const UserProfileImage = ({ onClick }) => {
  const { currentUser } = useAuth();
  const image = currentUser?.photoUrl ? currentUser?.photoUrl : null;

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"center"}
      style={userProfile}
      onClick={onClick}
    >
      <img src={image} style={imageStyles} />
      <span style={{ color: "#fff", cursor: "pointer" }}>
        {`${currentUser?.firstName} ${currentUser?.lastName}`}
        {/* {currentUser?.userName} */}
      </span>
    </Grid>
  );
};

export default UserProfileImage;

const userProfile = {
  position: "static",
  cursor: "pointer",
  width: "98%",
  paddingBottom: 16,
  paddingTop: 8,
};

const imageStyles = {
  boxShadow:
    "0 12px 20px -10px rgba(153, 153, 153, 0.42), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 0, 0, 0.2)",
  borderRadius: "50%",
  border: "none",
  // maxWidth: "35px",
  // objectFit: "contain",
  width: 52,
  height: 52,
};
